<div *ngIf="isLoading" class="fixed inset-0 flex items-center justify-center z-50 backdrop-blur-sm no-print">
  <i class="fas fa-spinner fa-spin text-6xl text-[#006269]"></i>
</div>

<div id="print-section" class="bg-gray-100 p-4 sm:p-8 print:bg-white print:p-0">
  <div class="max-w-5xl mx-auto bg-white shadow-lg border-[5px] transition-all"
    [style.borderColor]="customizeData?.colors?.outerBorder">

    <!-- Header -->
    <header class="p-6 border-b-2 text-center" [style.borderColor]="customizeData?.colors?.outerBorder">
      <h1 *ngIf="customizeData?.header?.mainTitle?.visible" class="text-2xl font-bold mb-2"
        [style.color]="customizeData?.header?.mainTitle?.color">
        {{ customizeData?.header?.mainTitle?.text }}
      </h1>
      <div class="flex justify-between text-sm px-8">
        <p>
          <strong [style.color]="customizeData?.header?.voucherLabel?.color">{{
            customizeData?.header?.voucherLabel?.text }}</strong>
          {{ invoiceData?.invoice_number }}
        </p>
        <p>
          <strong [style.color]="customizeData?.header?.dateLabel?.color">{{ customizeData?.header?.dateLabel?.text
            }}</strong>
          {{ invoiceData?.invoice_date }}
        </p>
      </div>
    </header>

    <!-- Main Table -->
    <section class="px-6 py-4">
      <div class="overflow-x-auto whitespace-nowrap hide-scrollbar mt-4">
        <table class="w-full text-sm text-center border-collapse">
          <thead [style.backgroundColor]="customizeData?.colors?.themeColor" class="text-white">
            <tr>
              <th *ngFor="let head of customizeData?.table?.headers" class="p-2 border border-gray-300"
                [style.color]="head.color" [class.hidden]="!head.visible">
                {{ head.text }}
              </th>
            </tr>
          </thead>
          <tbody>
            <!-- Grouped Items -->
            <tr *ngFor="let item of productItems; let i = index">
              <td class="p-2 border border-gray-300">{{ i + 1 }}</td>
              <td class="p-2 border border-gray-300 text-left">{{ item?.stout_item_name || item?.category?.name ||
                item?.stout_item_category }}</td>
              <td class="p-2 border border-gray-300">{{ item?.stout_total_wt | number:'1.2-2' }}</td>
              <td class="p-2 border border-gray-300">{{ item?.stout_purity || "-" }}</td>
              <td class="p-2 border border-gray-300">{{ item?.stout_quantity | number:'1.0-0' }}</td>
              <!-- Summed Pc count -->
              <td class="p-2 border border-gray-300">{{ item?.stout_unit_price || "-" }}</td>
              <td class="p-2 border border-gray-300">{{ item?.stout_mrp_percent || "-" }}</td>
              <td class="p-2 border border-gray-300">{{ item?.stout_quantity | number:'1.0-0' }}</td>
              <!-- Summed Quantity -->
              <td class="p-2 border border-gray-300">{{ item?.stout_per_gram_labour || "-" }}</td>
              <td class="p-2 border border-gray-300">{{ item?.stout_fine_weight | number:'1.2-2' }}</td>
              <td class="p-2 border border-gray-300">{{ item?.stout_final_amount | number:'1.2-2' }}</td>
            </tr>

            <!-- Total Row -->
            <tr class="font-semibold" [style.backgroundColor]="customizeData?.colors?.totalRowBg">
              <td colspan="2" class="p-2 border border-gray-300 text-center"
                [style.color]="customizeData?.summary?.totalLabel?.color">
                {{ customizeData?.summary?.totalLabel?.text }}
              </td>
              <td class="p-2 border border-gray-300">{{ itemsTotalWeight | number:'1.2-2' }} Gm</td>
              <td class="p-2 border border-gray-300"></td>
              <td class="p-2 border border-gray-300">{{ itemsTotalQty }}</td> <!-- Total Pieces -->
              <td colspan="4" class="p-2 border border-gray-300"></td>
              <td class="p-2 border border-gray-300">{{ itemsTotalFineWeight | number:'1.2-2' }} Gm</td>
              <td class="p-2 border border-gray-300">₹ {{ itemsTotalAmount | number:'1.2-2' }}</td>
            </tr>

            <!-- Silver Bhav Row -->
            <tr>
              <td colspan="2" class="p-2 border border-gray-300 text-left font-semibold"
                [style.color]="customizeData?.summary?.silverValueLabel?.color">
                {{ customizeData?.summary?.silverValueLabel?.text }}
                <ng-container *ngIf="invoiceData?.rateCutRate > 0; else defaultRate">
                  {{ invoiceData.rateCutRate | number:'1.0-0' }}
                </ng-container>
                <ng-template #defaultRate>
                  {{ itemsTotalFineWeight > 0 ? (amountWithSilver / itemsTotalFineWeight | number : '1.0-0') : 0 }}
                </ng-template>
              </td>
              <td colspan="7" class="p-2 border border-gray-300"></td>
              <td class="p-2 border border-gray-300">
                <ng-container *ngIf="invoiceData?.rateCutWeight > 0; else defaultWeight">
                  {{ invoiceData.rateCutWeight | number:'1.2-2' }} Gm
                </ng-container>
                <ng-template #defaultWeight>
                  {{ itemsTotalFineWeight | number:'1.2-2' }} Gm
                </ng-template>
              </td>
              <td class="p-2 border border-gray-300">
                <ng-container *ngIf="invoiceData?.rateCutAmount > 0; else defaultAmount">
                  ₹ {{ invoiceData.rateCutAmount | number:'1.2-2' }}
                </ng-container>
                <ng-template #defaultAmount>
                  ₹ {{ amountWithSilver | number:'1.2-2' }}
                </ng-template>
              </td>
            </tr>
            <!-- Metal Received Row -->
            <tr>
              <td colspan="2" class="p-2 border border-gray-300 text-left font-semibold"
                [style.color]="customizeData?.summary?.metalReceivedLabel?.color">
                {{ customizeData?.summary?.metalReceivedLabel?.text }} (GM)
              </td>

              <td colspan="8" class="p-2 border border-gray-300"></td>

              <td class="p-2 border border-gray-300 text-green-700 font-bold">
                {{ (invoiceData?.rateCutMetal || 0) | number:'1.1-1' }} gm
              </td>
            </tr>
            <!-- Previous Metal Row -->
            <tr *ngIf="Number(invoiceData?.computed_previous_silver_wt || invoiceData?.in_previous_silver_wt || invoiceData?.previous_silver_wt || invoiceData?.previous_metal || 0) !== 0">
              <td colspan="2" class="p-2 border border-gray-300 text-left font-semibold"
                [style.color]="customizeData?.summary?.previousMetalLabel?.color || '#000000'">
                {{ customizeData?.summary?.previousMetalLabel?.text || 'Previous Metal' }}
              </td>
              <td colspan="8" class="p-2 border border-gray-300"></td>
              <td class="p-2 border border-gray-300 text-red-600 font-bold">
                {{ Math.abs(Number(invoiceData?.computed_previous_silver_wt || invoiceData?.in_previous_silver_wt || invoiceData?.previous_silver_wt || invoiceData?.previous_metal || 0)) | number:'1.1-1' }} GM {{ Number(invoiceData?.computed_previous_silver_wt || invoiceData?.in_previous_silver_wt || invoiceData?.previous_silver_wt || invoiceData?.previous_metal || 0) >= 0 ? 'DR' : 'CR' }}
              </td>
            </tr>

            <!-- Previous Balance Row -->
            <tr *ngIf="Number(invoiceData?.in_previous_amount || invoiceData?.previous_amount || invoiceData?.previous_balance || 0) !== 0">
              <td colspan="2" class="p-2 border border-gray-300 text-left font-semibold"
                [style.color]="customizeData?.summary?.previousBalanceLabel?.color || '#000000'">
                {{ customizeData?.summary?.previousBalanceLabel?.text || 'Previous Balance' }}
              </td>
              <td colspan="8" class="p-2 border border-gray-300"></td>
              <td class="p-2 border border-gray-300 text-red-600 font-bold">
                ₹ {{ (invoiceData?.in_previous_amount || invoiceData?.previous_amount || invoiceData?.previous_balance || 0) | number:'1.2-2' }}
              </td>
            </tr>

            <!-- Cash Row -->
            <tr>
              <td colspan="2" class="p-2 border border-gray-300 text-left font-semibold"
                [style.color]="customizeData?.summary?.receiptCashLabel?.color">
                {{ customizeData?.summary?.receiptCashLabel?.text }}
              </td>
              <td colspan="8" class="p-2 border border-gray-300"></td>
              <td class="p-2 border border-gray-300 text-green-700 font-bold">₹ {{ invoiceData?.cash_amount }}</td>
            </tr>

            <!-- Closing Balance Row -->
            <tr class="font-bold" [style.backgroundColor]="customizeData?.colors?.balanceRowBg">
              <td colspan="10" class="p-2 border border-gray-300 text-right"
                [style.color]="customizeData?.summary?.closingBalanceLabel?.color">
                {{ customizeData?.summary?.closingBalanceLabel?.text }}
              </td>
              <td class="p-2 border border-gray-300" [style.color]="customizeData?.summary?.closingBalanceLabel?.color">
                ₹ {{ (invoiceData?.balance_due || 0) | number:'1.2-2' }}
              </td>
            </tr>
            <tr class="font-bold" [style.backgroundColor]="customizeData?.colors?.balanceRowBg">
              <td colspan="10" class="p-2 border border-gray-300 text-right"
                [style.color]="customizeData?.summary?.closingBalanceLabel?.color">
                Closing Metal
              </td>
              <td class="p-2 border border-gray-300" [style.color]="customizeData?.summary?.closingBalanceLabel?.color">
                {{ balanceSilverWt }} GM {{ (invoiceData?.balance_silver_wt || 0) >= 0 ? 'DR' : 'CR' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- PACKING LIST SECTION -->
    <section *ngIf="customizeData?.packaging?.visible" class="px-6 pt-4">
      <h3 *ngIf="customizeData?.packaging?.title?.visible" class="font-semibold mb-2 text-sm uppercase tracking-wide"
        [style.color]="customizeData?.packaging?.title?.color">
        {{ customizeData?.packaging?.title?.text }}
      </h3>

      <div *ngIf="packingSummary.length; else noPacking">
        <table class="w-full text-sm border-collapse border border-gray-300">
          <thead [style.backgroundColor]="customizeData?.colors?.packagingHeaderBg">
            <tr>
              <th *ngIf="customizeData?.packaging?.headers?.name?.visible" class="p-2 border border-gray-300 text-left"
                [style.color]="customizeData?.packaging?.headers?.name?.color">{{
                customizeData?.packaging?.headers?.name?.text }}</th>
              <th *ngIf="customizeData?.packaging?.headers?.qty?.visible" class="p-2 border border-gray-300 text-center"
                [style.color]="customizeData?.packaging?.headers?.qty?.color">{{
                customizeData?.packaging?.headers?.qty?.text }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let pack of packingSummary">
              <td *ngIf="customizeData?.packaging?.headers?.name?.visible" class="p-2 border border-gray-300">{{
                pack.minorName }}</td>
              <td *ngIf="customizeData?.packaging?.headers?.qty?.visible"
                class="p-2 border border-gray-300 text-center">{{ pack.quantity }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #noPacking>
        <p *ngIf="customizeData?.packaging?.emptyMessage?.visible" class="text-sm italic"
          [style.color]="customizeData?.packaging?.emptyMessage?.color">
          {{ customizeData?.packaging?.emptyMessage?.text }}
        </p>
      </ng-template>
    </section>

    <!-- Footer -->
    <section class="px-6 py-4 border-t border-gray-300 text-sm mt-4">
      <h2 *ngIf="customizeData?.footer?.termsTitle?.visible" class="font-bold mb-1"
        [style.color]="customizeData?.footer?.termsTitle?.color">
        {{ customizeData?.footer?.termsTitle?.text }}
      </h2>
      <p *ngIf="customizeData?.footer?.termsText?.visible" [style.color]="customizeData?.footer?.termsText?.color">
        {{ customizeData?.footer?.termsText?.text }}
      </p>
    </section>
  </div>
</div>

<div class="flex justify-center no-print pb-10 mt-6">
  <button (click)="printInvoice()"
    class="block m-2 cursor-pointer capitalize w-[200px] p-3 text-lg font-bold bg-[#006269] text-white rounded-md shadow-lg hover:opacity-90">
    Print Estimate
  </button>
</div>